import { ReactNode } from 'react';

import styles from './ConfigBlockShell.module.scss';

/** Normalizes a config value for display, rendering empties as an em dash. */
export function emptyVal( v: unknown ): string {
  if ( v === undefined || v === null || v === '' ) return '—';
  if ( typeof v === 'object' ) return JSON.stringify( v );
  return String( v );
}

export function Field( { label, value, full }: { label: string; value: string; full?: boolean } ) {
  return (
    <div className={ full ? styles.fieldFull : styles.field }>
      <div className={ styles.fieldLabel }>{ label }</div>
      <div className={ styles.fieldValue }>{ value }</div>
    </div>
  );
}

/**
 * Gray rounded card with an icon + title header and a responsive grid of
 * {@link Field}s. Shared by the source and metric config-detail blocks.
 */
export function ConfigBlockShell( { title, icon, children }: { title: string; icon: ReactNode; children: ReactNode } ) {
  return (
    <section className={ styles.block } data-testid="config-block">
      <header className={ styles.blockHeader }>
        <span className={ styles.blockIcon } aria-hidden="true">{ icon }</span>
        <h3 className={ styles.blockTitle }>{ title }</h3>
      </header>
      <div className={ styles.fields }>{ children }</div>
    </section>
  );
}
